import React, {PureComponent, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import cxs from 'cxs/component'
import Theme from 'Theme'

interface Props {
  image?: string | ArrayBuffer | null
  children?: JSX.Element
}

class BackgroundImage extends PureComponent<Props, object> {
  render() {
    const {image: _image, children, ...props} = this.props
    const image = typeof _image === 'string'
      ? _image
        ? _image.indexOf('base64') >= 0
          ? _image
          : process.env.REACT_APP_SERVER! + _image
        : require('images/placeholder.png')
      : typeof _image === 'object' && _image instanceof ArrayBuffer?  _image
        : require('images/placeholder.png')
    return (
      <Wrapper {...props}>
        <Image image={image}>{children}</Image>
      </Wrapper>
    )
  }
}

export default BackgroundImage

const Wrapper = cxs('div')({
  position: 'relative',
  margin: '0 auto',
  padding: Theme.size.space[2],
  overflow: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  outline: '1px solid #eee'
})

const Image = cxs('div')(
  ({image}) =>
    ({
      backgroundImage: image
        ? `url(${image})`
        : `url(${require('images/placeholder.png')})`,
      width: '100%',
      paddingBottom: '100%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain'
    } as CSSProperties)
)

Image.propTypes = {
  image: PropTypes.string
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/BackgroundImage.tsx